import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    iframe: {
        minHeight: 850,
        width: "100%",
        border: "none",
    },
    saveCard: {
        paddingBottom: theme.spacing(2),
    },
}));
